import { getWizardDataFromDataRows } from './chart-wizard/get-wizard-data-from-data-rows';
import { ActionTypes, createInitialState, createState, fontNames, fontSizes, isCategorical, mergeStates, parseFont, updateState } from './chart-wizard/state';
import {
    messages
} from './chart-wizard/messages';

export var ChartWizardCommon = Object.freeze({
    getWizardDataFromDataRows: getWizardDataFromDataRows,
    ActionTypes: ActionTypes,
    createInitialState: createInitialState,
    createState: createState,
    fontNames: fontNames,
    fontSizes: fontSizes,
    isCategorical: isCategorical,
    mergeStates: mergeStates,
    parseFont: parseFont,
    updateState: updateState,
    messages: messages
});
